var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreLocator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5c0 1.806-1.14 3.56-2.37 4.914A16.947 16.947 0 015 11.877a16.946 16.946 0 01-2.13-1.963C1.64 8.56.5 6.806.5 5a4.5 4.5 0 019 0z",
    stroke: "#000"
  })));
}
export default SvgStoreLocator;